export const SUPPORTED_LANG = {
  hi: 'hi', // <-- DEFAULT LANG
  en: 'en',
  bn: 'bn',
  mr: 'mr',
  gu: 'gu',
}

export const NAMESPACE = {
  common: 'common',
}

export const TRACTTOR_GIF_URL =
  'https://s3-alpha-sig.figma.com/img/ab17/7f09/cd0fe35a0b3d1b9b7c4dc0bccd3eaa51?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=TFYZNBPCeQ9ceT9CHDkxDaRPzSyS54e3ZELz~d67GUVHua66b0cpiWyPw1ZCv8TIuDegHtq~UVvZW1NdfF6x0aZFOi5nbFcKs6BWFI3VmJ6rqLzn1BGrBXaSP9AJipmKNdsRlgObeUoryWADgAT11XflgvtNlKxnHgeoc01r2ANHjDas~0H31NLX3E86bruZiXdyVumGjrERNa4pUm1qk2ij1OoHVrOyx14wr-OCkgl0w0oHAPfmn3OIuOxNSm58beB~h~fByRvfU0C6bAszz2OtJSo~NpMbIUGtrgeLZeC~GCS9NJA8Y68Q27ISiMaVhmfHgmhyWhxO1h3v~9iyLw__'

export const TECH_SUPPORT_EMAIL = 'techsupport@agrevolution.in'
